import React from "react";

export default function FA5_Construction() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">FA5_Construction</h2>
      <p>Route: /icons/fa5/construction</p>
    </div>
  );
}
